import React from 'react'
import LogoLivBrite from 'app/livbrite/resources/images/livBrite_logo.png'
import { ReportData } from 'hooks/reports'
import { Details, Wrapper, Header, Footer, Container, WholeWrapper } from './styled'
import { ReportInfo } from '../ReportInfo'

interface Props {
  pdf: React.MutableRefObject<HTMLDivElement | null>
  report?: ReportData
  community?: string
  dateRange?: string
}

export const PDF = ({ pdf, report, community, dateRange }: Props) => {
  return (
    <WholeWrapper>
      <div
        ref={pdf}
      >
        <Container>
          <Header>
            <img alt='' src={LogoLivBrite} />
            <div>
              <Details>Community Name: {community}</Details>
              {dateRange && (
                <Details>Date Range: {dateRange}</Details>
              )}
            </div>
          </Header>
          <Wrapper>
            {report && (
              <ReportInfo isPDF report={report} />
            )}
          </Wrapper>
          <Footer>
            <span>To get a detailed report, please download the .CSV version</span>
          </Footer>
        </Container>
      </div>
    </WholeWrapper>
  )
}
